import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import { Layout, Row, Col, Modal } from "antd";

import Sidebar from "./components/menu/Sidebar";
import MenuHeader from "./components/header";
import { getUserCustomerList, UserLogout } from "../redux/login/loginActions";
import UserCustomerModal from "../view/userCustomerModal";
import { uniqueValues } from "../utils/utils";

const { Content } = Layout;

export default function VerticalLayout(props) {
    const { children } = props;

    const [visible, setVisible] = useState(false);
    const [redirect, setRedirect] = useState(false);
    const [redirectToPage, setRedirectToPage] = useState("/login");
    const [isCustomerModalVisible, setIsCustomerModalVisible] = useState(false);
    const [openingViaLogin, setOpeningViaLogin] = useState(false);
    const [customerListState, setCustomerListState] = useState([]);

    const customise = useSelector(state => state.customise);
    const { authorizedPages, authorizedPagesLoaded } = useSelector((state) => state.settings);
    const { isAuthenticated, userCustomerList } = useSelector((state) => state.login);

    useEffect(() => {
        const fetchData = async () => {
            await getUserCustomerList({ email: localStorage?.getItem("user") });
        };
        fetchData();
    }, []);

    useEffect(() => {
        const uniqueCustomerList = uniqueValues(userCustomerList, "cardCode", "cardName", "concatenate");
        const sortedCustomerList = uniqueCustomerList?.sort((a, b) => a.props.children.localeCompare(b.props.children));

        setCustomerListState(sortedCustomerList);
    }, [userCustomerList]);

    useEffect(() => {
        const url = new URL(window.location.href);
        const pathName = url.pathname;
        const searchParams = new URLSearchParams(url.search);
        const isUpdate = searchParams.has('id');

        if (authorizedPagesLoaded) {
            if (!authorizedPages || authorizedPages?.length === 0 || authorizedPages?.every(page => page.permission === "" || page.permission === null)) {
                showErrorModal();
            }
            else {
                var permissionForCurrentPage = false;
                var redirectTo = "/login";

                for (var i = 0; i < authorizedPages?.length; i++) {
                    let parentPermission = authorizedPages[i].permission ? authorizedPages[i].permission.split(',').map(permission => permission.trim()) : [];

                    if (redirectTo == "/login" && (parentPermission.includes('view') || parentPermission.includes('add') || parentPermission.includes('update') || parentPermission.includes('full'))) {
                        redirectTo = authorizedPages[i].screen;
                    };

                    if (authorizedPages[i].screen === pathName) {
                        const hasPermission = parentPermission.includes('view') || parentPermission.includes('add') || parentPermission.includes('update') || parentPermission.includes('full');
                        if (hasPermission) {
                            permissionForCurrentPage = true;
                        };
                    }
                    else if (authorizedPages[i].subPages && authorizedPages[i].subPages?.length > 0) {
                        const subPage = authorizedPages[i].subPages.find(page => page.subScreen === pathName);

                        if (subPage) {
                            if ((isUpdate && (parentPermission.includes('update') || parentPermission.includes('full')))
                                || (!isUpdate && (parentPermission.includes('add') || parentPermission.includes('full')))
                                || (subPage.parentScreen === '/setting/user-profile' && (parentPermission.includes('view') || parentPermission.includes('full') || parentPermission.includes('add') || parentPermission.includes('update')))) {
                                permissionForCurrentPage = true;
                            }
                        }
                    }
                    // else if (["/orders", "/deliveries", "/invoices", "/payments", "/payment-reports", "/service-calls", "/return-request", "/create-return", "/create-supply-order", "/contracts", "/equipment-details", "/place-order"].includes(pathName)) {
                    //     {/*remove else-if after value is given in authorized pages api*/ }
                    //     permissionForCurrentPage = true;
                    // };

                    if (permissionForCurrentPage) {
                        break;
                    };
                };

                if (redirectTo == "/login") {
                    showErrorModal();
                }
                else if (!permissionForCurrentPage) {
                    setRedirectToPage(redirectTo);
                    setRedirect(true);
                };
            };
        };
    }, [window.location.href, authorizedPagesLoaded]);

    const showErrorModal = () => {
        Modal.error({
            title: 'Error',
            content: 'You are not authorized to use this application. For assistance, please contact your administrator.',
            okText: 'OK',
            cancelButtonProps: {
                style: { display: 'none' }
            },
            onOk: () => {
                UserLogout();
                window.location.reload();
            }
        });
    };

    useEffect(() => {
        if (isAuthenticated && !localStorage.getItem('cardCode') && userCustomerList && userCustomerList?.length > 1) {
            setIsCustomerModalVisible(true);
            setOpeningViaLogin(true);
        }
    }, [isAuthenticated, userCustomerList]);

    const handleCustomerCancel = () => {
        setIsCustomerModalVisible(false);
    };

    const handleCustomerOk = () => {
        setIsCustomerModalVisible(false);
    };

    if (redirect) {
        setTimeout(() => {
            setRedirect(false);
        }, 20);
        return (<Redirect to={redirectToPage} />);
    };

    return (
        isAuthenticated ?
            (<Layout className="hp-app-layout">
                <Sidebar visible={visible} setVisible={setVisible} />
                <Layout>
                    <MenuHeader setVisible={setVisible} />
                    <Content className="hp-content-main">
                        <Row justify="center">
                            {customise.contentWidth === "full" &&
                                (<Col span={24}>
                                    {children}
                                </Col>)}
                            {customise.contentWidth === "boxed" &&
                                (<Col className="hp-w-100" style={{ maxWidth: 936 }}>
                                    {children}
                                </Col>)}
                        </Row>
                    </Content>
                </Layout>
                <UserCustomerModal
                    openingViaLogin={openingViaLogin}
                    isVisible={isCustomerModalVisible}
                    onOk={handleCustomerOk}
                    onCancel={handleCustomerCancel}
                    customerListState={customerListState}
                    userCustomerList={userCustomerList}
                />
            </Layout>)
            : (<Redirect to="/login" />)
    );
};  